export enum CommodityResultTypeEnum {
  COMMODITY = "COMMODITY",
  DANGEROUS_GOOD = "DANGEROUS_GOOD",
}
